import { useEffect, useState } from 'react';
export const useIsScrolled = () => {
  const [isScrolled, setIsScrolled] = useState(window.scrollY > 0);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 0);
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return isScrolled;
};
//# sourceMappingURL=useIsScrolled.js.map